
import { $,_,moment } from '../../../vendor';
import { Backform,Notification, } from '../../utils';
import InboomaBaseView from '../InboomaBaseView';
import InboomaBaseCollectionView from '../InboomaBaseCollectionView';

import OffCanvasBehavior from '../../behaviors/Behavior.OffCanvas'

import NumberDiscountTpl from '../../templates/pricediscounts/NumberDiscount.html';

const NumberDiscountView = InboomaBaseView.extend({

    template : NumberDiscountTpl,

    ui : {
        dropdown : '.inb-dropdown',
        toggleBtn : '.inb-toggle-order-dd',
        selectRole : '.inb-role-select',
        removeUser : '.inb-pricediscount-remove',
    },

    events : {
        'change @ui.selectRole' : '_roleChanged',
        'click @ui.removeUser' : '_removeUser',
    },

    templateContext () {
        return {
            _,
            moment
        }
    },


    onRender () {

        const that = this;

        const fields = [
            {
                name: "description",
                control: "input",
                helpMessage: (this.model.get('description') == '' ? this.t('no_special_char_allowed') : ''),
                required: true,
                size : {
                    "large" : "5"
                }
            },{
                name: "discount_nbr",
                control: "input",
                required: true,
                size : {
                    "small" : "3"
                }
            }, {
                name : "discount_amount",
                control : "input",
                required: false,
                size : {
                    "small" : "1"
                }
            },{
                name: "discount_percent",
                control: "input",
                required: false,
                size : {
                    "small" : "1"
                }
            }, {
                name: "active",
                control: "checkbox",
                required: false,
                size : {
                    "small" : "1"
                }
            }, {
                name: "combineable",
                control: "checkbox",
                required: false,
                size : {
                    "small" : "1"
                }
            }, {
                control: "spacer",
                size: {
                    "small" : "8",
                    "large" : "4"
                },
            },{
                // @TODO begin & end: make require & controle variable
                name: "valid_from",
                label: this.t('valid_from',null,'capital'),
                control: "datetimepicker",
                //required: true,
                minDate: null,
                size : {
                    "small" : "6",
                    "large" : "3"
                },
                triggerPicker: 'valid_to'
            }, {
                name: "valid_to",
                label: this.t('valid_to',null,'capital'),
                minDate:  null,
                control: "datetimepicker",
                //required: true,
                size : {
                    "small" : "6",
                    "large" : "3"
                }
            },{
                control: "spacer",
                size: {
                    "small": "2",
                    "large": "1"
                }
            },{
                name: "save",
                control: "button",
                controlClass: ['discount_save'],
                label: this.t("save",null,"capital"),
                size: {
                    "small": "2",
                    "large": "1"
                }
            }

        ];

        this.form = new Backform.Form({

            el: that.$el.find('form'),
            model: this.model,
            fields: fields,
            events : {
                "click .button" : (ev) => {
                    // Does exactly what OffCanvasBehavior does...
                    ev.preventDefault();
                    this.$el.find('form button[type="submit"]').prepend('<img class="rollingLoader" src="assets/img/rolling_loader.svg" />');

                    // @todo use InboomaBaseModel mixin
                    this.model = OffCanvasBehavior.prototype.normalizeModel(this.model);
                    this.model.attributes.valid_from = (this.model.get('valid_from') !=null)?OffCanvasBehavior.prototype.makeApiTime(this.model.get('valid_from')):null;
                    this.model.attributes.valid_to = (this.model.get('valid_to') !=null)?OffCanvasBehavior.prototype.makeApiTime(this.model.get('valid_to')):null;

                    that.$el.removeClass('.model-changed');

                    this.model.save(null,{
                        success: (model, response, options) => {

                            that.$el.find('.rollingLoader').fadeOut('fast')

                            that.$el.find('.accordion-title').trigger('click'); //removeClass('is-active');
                            //model.set('contingents', response.data.contingents[0].id);

                            new Notification({
                                message : that.t('saved_${a}',{a:that.t('client_discount')},null,'capital'),
                                duration : 5000,
                                type : 'success',
                                closeable : true,
                                icon : 'fi fi-check'
                            });



                            //that.model.trigger('changed');
                            //that.render();
                            document.location.href = "/pricediscounts/client_discount";

                        }, error: function(model, xhr, options) {

                            that.$el.find('.accordion-item').removeClass('is-active');

                            new Notification({
                                message : that.t('request_error'),
                                duration : 5000,
                                type : 'warning',
                                closeable : true,
                                icon : 'fi fi-x'
                            });

                        }});

                }
            }
        });
        $('.inb-c-left-bar__footer').removeClass('hide');

        this.form.render();

    }


});

export default InboomaBaseCollectionView.extend({

    childView: NumberDiscountView,
    template: _.noop,
    initialize: function () {
        const that = this;
        if(that.id){
            this.collection.filterById(that.id);
        }else{
            this.collection.filterByType('discount_nbr');
        }
        InboomaBaseCollectionView.prototype.initialize.apply(this);
        that.$el.html('');
        $('.inb-c-left-bar__footer').removeClass('hide');
        that.render();
    }
});